import _ from 'underscore';
import FlowUtil from './../FlowUtil';

export default function (step, Q) {
    var _doActionOp = void 0;
    var _doActionMsgs = void 0;
    var _doActionCallbacks = void 0;
    var _goToOp = void 0;
    var _branchOp = void 0;
    var transitionSet = false;

    function transition(stepNameOrBranchFn) {
        return function (model, extraArgs) {
            if (_.isString(stepNameOrBranchFn) || FlowUtil.isStepObject(stepNameOrBranchFn) || FlowUtil.isJunctionObject(stepNameOrBranchFn)) {
                // step name
                return stepNameOrBranchFn;
            }
            // branch function
            return stepNameOrBranchFn(model, extraArgs);
        };
    }

    function action(actionFn, callbacks) {
        return function (model) {
            var extraArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var updateModelPromise = actionFn(model, extraArgs);
            if (!updateModelPromise || !updateModelPromise.then) {
                throw new Error('Action function should return a promise: ' + actionFn);
            }
            return updateModelPromise.then(function (modelAfterPromise) {
                if (modelAfterPromise.errorsAndWarnings.value != undefined && modelAfterPromise.errorsAndWarnings.underwritingIssues.value != undefined && modelAfterPromise.errorsAndWarnings.underwritingIssues.value.length > 0) {
                    return {
                        model: modelAfterPromise,
                        step: "error",
                        extraArgs: extraArgs
                    };
                }
                var actionSuccessTransition = callbacks.success(modelAfterPromise, extraArgs);
                if (!actionSuccessTransition) {
                    throw new Error('Undefined result returned from action success transition');
                }
                return {
                    model: modelAfterPromise,
                    step: actionSuccessTransition,
                    extraArgs: extraArgs
                };
            }, function (errorFromAction) {
                var actionErrorTransition = callbacks.error(errorFromAction, extraArgs);
                if (!actionErrorTransition) {
                    throw new Error('Undefined result returned from action error transition');
                }
                extraArgs.error = errorFromAction;
                return Q.reject({
                    model: model,
                    step: actionErrorTransition,
                    extraArgs: extraArgs
                });
            });
        };
    }

    return {
        /**
         * Defines an action to call before going to a new step
         *
         * @param {Function}  doActionFn - Function that takes in the model and returns a promise that resolves to {model, extraArgs}
         * @param {Object}  actionMsgs - Progress, Success and Error messages associated with action. Typically used for
         *                               with dialog messages.
         *
         * @returns {*} If parameters are supplied then returns an object with thenGoTo and thenBranch properties otherwise
         *              if no parameters are supplied then an object representing the action is returned.
         *              Any extraParams will be bound to the action function.
         */
        doAction: function doAction(doActionFn, actionMsgs) {
            if (arguments.length === 0) {
                return _doActionOp ? {
                    action: _doActionOp,
                    msgs: _doActionMsgs,
                    callbacks: _doActionCallbacks
                } : undefined;
            }
            if (transitionSet) {
                throw new Error('A step definition can only have one doAction, goTo or branch property set');
            }
            transitionSet = true;
            // object used to store what function to call when action promise is resolved
            // functions are set on object in thenGoTo and thenBranch
            var callbacks = {
                success: undefined,
                error: undefined
            };
            _doActionOp = action(doActionFn, callbacks);
            _doActionMsgs = actionMsgs;
            _doActionCallbacks = callbacks;
            return {
                thenGoTo: function thenGoTo(successStep, errorStep) {
                    callbacks.success = transition(successStep);
                    callbacks.error = transition(errorStep);
                    return step;
                },
                thenBranch: function thenBranch(successFn, errorFn) {
                    callbacks.success = transition(successFn);
                    callbacks.error = transition(errorFn);
                    return step;
                }
            };
        },


        /**
         * Defines a transition to a new step
         *
         * @param {String|Object}  stepNameOrStepObject - String identifying the next step or a step object
         *
         * @returns {*} If parameters are supplied then undefined is returned
         *              if no parameters are supplied then a string or object representing the next step returned
         */
        goTo: function goTo(stepNameOrStepObject) {
            if (arguments.length === 0) {
                return _goToOp;
            }
            if (transitionSet) {
                throw new Error('A step definition can only have one doAction, goTo or branch property set');
            }
            transitionSet = true;
            _goToOp = transition(stepNameOrStepObject);
            return step;
        },


        /**
         * Defines a branch function that returns the next step in the flow
         *
         * @param {Function}  branchFn - Function that returns the next step
         *
         * @returns {*} If parameters are supplied then undefined is returned
         *              if no parameters are supplied then the branch function. Any extraParams will be bound to the
         *              branch function.
         */
        branch: function branch(branchFn) {
            if (arguments.length === 0) {
                return _branchOp;
            }
            if (transitionSet) {
                throw new Error('A step definition can only have one doAction, goTo or branch property set');
            }
            transitionSet = true;
            _branchOp = transition(branchFn);
            return step;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/flow/build/Next.js
// module id = 260
// module chunks = 0